/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {DataGroup} from './data-group';
import {GenericDrivenEntity} from '../entity/generic-driven-entity';
import {Factory} from '../../engine/http/factory/factory';

export class DataGroupFactory implements Factory<DataGroup> {
  api: string;

  wsKey;
  wsLib;
  wsItems;

  constructor(api?: string) {
    this.api = api;
  }

  build(o: any): DataGroup {
    const dataGroup = new DataGroup(this.wsKey, this.wsLib, this.wsItems);

    dataGroup[dataGroup.idField] = o[dataGroup.idField];
    dataGroup[dataGroup.labelField] = o[dataGroup.labelField];

    for (const tempItem of o[dataGroup.itemsField]) {
      const item = new GenericDrivenEntity();
      // tslint:disable-next-line:forin
      for (const attr in tempItem) {
        item[attr] = tempItem[attr];
      }
      dataGroup.pushItem(item);
    }
    return dataGroup;
  }

  getApi(): string {
    return this.api;
  }
}
